export { default as configureStore } from './configureStore';
export {
    customEvent,
    errorFetchingWidgetData,
    errorFetchingWidgetTemplate,
    loadingWidgetData,
    loadingWidgetTemplate,
    setCapabilitiesLoaded,
    setReportSite,
    setReportTime,
    setTime,
    setTimeForAllWidgetBlocks,
    widgetDataLoaded,
    widgetTemplateLoaded,
} from './widgetblock/actions';
